import React from "react"
import Item from "./item"
import * as s from "./index.module.scss"

type Props = {
  posts: GatsbyTypes.ContentfulNews[]
}

const Component: React.FC<Props> = ({ posts }) => {
  const count = posts.length

  return (
    <div
      className={s.list}
      data-count={`${count}`}
    >
      {posts.map((post, index) => (
        <Item post={post} key={index} />
      ))}
    </div>
  )
}

export default Component
